module.exports = __webpack_public_path__ + "static/media/googleIcon.a57de0b7.svg";